// @ts-nocheck
import { Icon } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import Chart from "@store/Library/Components/Reporting/LinkCard/Chart";
import Colors from "@store/Themes/common/styleguide/config/colors";
import React from "react";
import styled from "styled-components";

const IconCircle = styled.div`
    width: 75px;
    border: 2px solid ${getColor("common.backgroundColorLightWarmGrey")};
    height: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
`;
interface Props {
    color: string;
}

const CardIconCircle: React.FC<Props> = ({ color }) => {
    const strokeColor = color === Colors?.primary?.contrast ? "black" : "white";
    return (
        <IconCircle
            style={{
                backgroundColor: color,
            }}
        >
            <Icon size={37.5} src={() => Chart({ stroke: strokeColor })} />
        </IconCircle>
    );
};

export default CardIconCircle;
